import TargetSkillIconSvg from './TargetSkillIcon.svg?react';

const TargetSkillIcon = () => {
    return (
        <TargetSkillIconSvg />
    );
};

export default TargetSkillIcon;